import type {
  DocumentCount,
  FilterMap,
} from '../DNA/Document/DNADocumentFilters';

type FilterValue = FilterMap[string]['values'][string];
type VideoTypes = Record<string, unknown>;
type FilterCategory = readonly [string, {
  fieldName: string,
  values: FilterMap[string]['values'],
}];

export type VisibleFilterValueEntry = [string, FilterValue, number];
export type VisibleFilterCategoryEntry = [string, FilterCategory[1], VisibleFilterValueEntry[]];

export const getFilterValueCount = (
  documentsCount: DocumentCount,
  fieldId: string,
  valueId: string,
  videoTypes: VideoTypes = {},
): number => {
  if (valueId === 'VIDEO') {
    return Object.entries(documentsCount[fieldId] ?? {}).reduce((count, [type, typeCount]) => (
      videoTypes[type] ? count + typeCount : count
    ), 0);
  }

  return documentsCount[fieldId]?.[valueId] ?? 0;
};

export const getVisibleFilterValueEntries = (
  values: FilterMap[string]['values'],
  documentsCount: DocumentCount,
  videoTypes: VideoTypes = {},
): VisibleFilterValueEntry[] => {
  return Object.entries(values)
    .map(([key, value]) => [
      key,
      value,
      getFilterValueCount(documentsCount, value.fieldId, value.valueId, videoTypes),
    ] as VisibleFilterValueEntry)
    .filter(([, , count]) => count > 0);
};

export const getVisibleFilterCategoryEntries = (
  categories: FilterCategory[],
  documentCountsByField: Record<string, DocumentCount>,
  videoTypes: VideoTypes = {},
): VisibleFilterCategoryEntry[] => {
  return categories
    .map(([key, field]) => {
      const firstValue = Object.values(field.values)[0];
      const documentsCount = firstValue ? documentCountsByField[firstValue.fieldId] || {} : {};
      const visibleValues = getVisibleFilterValueEntries(field.values, documentsCount, videoTypes);

      return [key, field, visibleValues] as VisibleFilterCategoryEntry;
    })
    .filter(([, , visibleValues]) => visibleValues.length > 0);
};
